import { cn } from "@/lib/utils";
import { IconLayoutNavbarCollapse } from "@tabler/icons-react";
import { AnimatePresence, motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { NavItem } from "./types";

interface FloatingDockMobileProps {
  items: NavItem[];
  className?: string;
}

export function FloatingDockMobile({ items, className }: FloatingDockMobileProps) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <div className={cn("relative block md:hidden mx-auto w-fit", className)}>
      <AnimatePresence>
        {open && (
          <motion.div
            layoutId="nav"
            className="absolute top-full mt-2 flex flex-col gap-2 items-center bg-background/80 backdrop-blur-sm p-2 rounded-lg border shadow-lg"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
          >
            {items.map((item, idx) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 10 }}
                animate={{
                  opacity: 1,
                  y: 0,
                }}
                exit={{
                  opacity: 0,
                  y: 10,
                  transition: {
                    delay: idx * 0.05,
                  },
                }}
                transition={{ delay: (items.length - 1 - idx) * 0.05 }}
              >
                <Link
                  to={item.href}
                  onClick={() => setOpen(false)}
                  className={cn(
                    "h-10 w-10 rounded-full flex items-center justify-center transition-colors",
                    location.pathname === item.href
                      ? "bg-primary text-primary-foreground"
                      : "bg-gray-50 dark:bg-neutral-900 hover:bg-primary/90 hover:text-primary-foreground"
                  )}
                >
                  <div className="h-4 w-4">{item.icon}</div>
                </Link>
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
      <button
        onClick={() => setOpen(!open)}
        className="h-10 w-10 rounded-full bg-gray-50 dark:bg-neutral-800 flex items-center justify-center shadow-lg border transition-colors hover:bg-primary/90 hover:text-primary-foreground"
      >
        <IconLayoutNavbarCollapse className="h-5 w-5" />
      </button>
    </div>
  );
}